












































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class SearchPanel extends Vue {
  /**
   * 将搜索按钮显示在上面一排
   */
  @Prop({
    default: false,
  })
  public isTop: boolean;
  @Prop({
    default: false,
  })
  public isover: boolean;
  @Prop({
    default: true,
  })
  public isReset: boolean;
  @Prop({
    default: false,
  })
  public loading: boolean;
  @Prop({
    default: false,
  })
  public isMore: boolean;
  @Prop({
    default: false,
  })
  public isExtend: boolean;
  @Prop({
    default: false,
  })
  public isDialog: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue